import {
  Configurator,
  ConfiguratorCoreConfig,
  RulebasedConfiguratorAdapter,
  RulebasedConfiguratorConnector,
} from '@spartacus/product-configurator/rulebased';
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {EMPTY, Observable, of} from 'rxjs';
import {CommonConfigurator, CommonConfiguratorUtilsService} from '@spartacus/product-configurator/common';
import {catchError, filter} from 'rxjs/operators';
import {CartModification} from '@spartacus/cart/base/root';
import {isPlatformBrowser} from '@angular/common';
import {ICartDecoratorErrorHandlingService} from '../interfaces';
import {serviceProviderTokens} from '../token/tokens';

@Injectable()
export class DcpRulebasedConfiguratorConnector extends RulebasedConfiguratorConnector {
  constructor(
    @Inject(PLATFORM_ID) public platformId: string,
    @Inject(RulebasedConfiguratorConnector.CONFIGURATOR_ADAPTER_LIST)
    protected override adapters: RulebasedConfiguratorAdapter[],
    protected override configUtilsService: CommonConfiguratorUtilsService,
    @Inject(serviceProviderTokens.CART_DECORATOR_ERROR_HANDLING_SERVICE_PROVIDER)
    private cartDecoratorErrorHandlingService: ICartDecoratorErrorHandlingService,
    configuratorCoreConfig: ConfiguratorCoreConfig,
  ) {
    super(adapters, configUtilsService, configuratorCoreConfig);
  }

  override createConfiguration(
    owner: CommonConfigurator.Owner,
    configIdTemplate?: string,
    forceReset: boolean = false,
  ): Observable<Configurator.Configuration> {
    return this.getAdapter(owner.configuratorType)
      .createConfiguration(owner, configIdTemplate, forceReset)
      .pipe(this.handleError.bind(this));
  }

  override updateConfiguration(configuration: Configurator.Configuration): Observable<Configurator.Configuration> {
    return this.getAdapter(configuration.owner.configuratorType)
      .updateConfiguration(configuration)
      .pipe(this.handleError.bind(this));
  }

  /**
   * addToCart for PartnerProducts return a targetUrl which is redirected to.
   * In that case the Subscriptions is closed (filtered)
   */
  override addToCart(parameters: Configurator.AddToCartParameters): Observable<CartModification> {
    return this.getAdapter(parameters.owner.configuratorType)
      .addToCart(parameters)
      .pipe(
        filter((response: any) => {
          if (response?.targetUrl && isPlatformBrowser(this.platformId)) {
            window.location.assign(response.targetUrl);
            return false;
          }
          return true;
        }),
      );
  }

  private handleError(source$: Observable<Configurator.Configuration>): Observable<Configurator.Configuration> {
    return source$.pipe(
      catchError((error) => {
        this.cartDecoratorErrorHandlingService.handle(error, null);
        return EMPTY;
      }),
    );
  }

  override readPriceSummary(configuration: Configurator.Configuration): Observable<Configurator.Configuration> {
    return of(configuration);
  }
}
